//User management
export enum USER_MODAL_TYPES {
  RESEND = "resend",
  EDIT = "edit",
  INVITE = "invite",
}

export const ROLE_DISPLAY_VALUE = {
  Admin: "CUSTOMER_ORG_ADMIN",
  User: "CUSTOMER_ORG_USER",
};
